
<div class="splash-container splash-container-loading" *ngIf="loading">
  <div class="loading-animation">
    <div class="loading-column left"></div>
    <div class="loading-column middle"></div>
    <div class="loading-column right"></div>
  </div>

  <div class="loading-container">
    <h2>{{ 'splash.loading.title' | translate }}</h2>
    <p>{{ 'splash.loading.subtitle' | translate }}</p>
  </div>
</div>

<div class="splash-container splash-container-error" *ngIf="error">
  
  <div class="error-container">
    <img src="../../assets/QrCode.svg" alt="QR code error">
    <h2>{{ 'splash.error.title' | translate }}</h2>
    <p class="error-message">{{ 'splash.error.message' | translate }}</p>
  </div>
</div> 